// First element of the visible breadcrumb and of the BreadcrumbList schema
// (eBay-style brand root linking to /s). One constant so they cannot diverge.
// Lives here (not in SearchPage.shared) so that components outside SearchPage
// can render the breadcrumb without pulling in the whole shared module.
export const SEARCH_BREADCRUMB_ROOT_LABEL = 'Avento';

// NamedLink route props for /s/:cat1/:cat2/:cat3 category pages,
// built from an ordered array of category ids.
export const searchRoutePropsForIds = (ids = []) => {
  const [cat1, cat2, cat3] = ids;
  const params = {
    ...(cat1 ? { cat1 } : {}),
    ...(cat2 ? { cat2 } : {}),
    ...(cat3 ? { cat3 } : {}),
  };
  return { name: ids.length === 0 ? 'SearchPage' : `SearchPageCat${ids.length}`, params };
};
